import script from "./PairScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./PairScreen.vue?vue&type=script&setup=true&lang=js"

import "./PairScreen.vue?vue&type=style&index=0&id=4959dacf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4959dacf"]])

export default __exports__